document.addEventListener("DOMContentLoaded", function () {
  
  // 🧩 1. Filter Silver Swiper
  var filter_silver_swiper = new Swiper(".filter_silver_swiper", {
    slidesPerView: 6,
    spaceBetween: 20,
    breakpoints: {
      320: { slidesPerView: 2.2 },
      576: { slidesPerView: 3 },
      770: { slidesPerView: 3.5 },
      991: { slidesPerView: 4 },
      992: { slidesPerView: 6 },
    },
  });

  // 🧩 2. Hero Swiper
  var hero_swiper = new Swiper(".hero_swiper", {
      loop: true,
      effect: 'fade',
      fadeEffect: {
          crossFade: true,
      },
      speed: 1500,   
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,  
      },

      simulateTouch: false,
      allowTouchMove: false,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      on: {
        slideChangeTransitionStart: function () {
          let activeSlide = this.slides[this.activeIndex];
          let animatedEls = activeSlide.querySelectorAll(".hero_product_img");

          animatedEls.forEach(el => {
            el.classList.remove("start-animation");
            void el.offsetWidth;
            el.classList.add("start-animation");
          });
        },
      },

      breakpoints: {
        0: { // mobile
            simulateTouch: true,
            allowTouchMove: true,
        },
        768: { // tablet
            simulateTouch: true,
            allowTouchMove: true,
        },
      
      },
});


  // 🧩 3. Filtered Products Swiper
  var filtered_products_swiper = new Swiper("#filtered-products", {
    slidesPerView: 4.2,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: { slidesPerView: 1.2 },
      576: { slidesPerView: 2.2 },
      770: { slidesPerView: 2.2 },
      991: { slidesPerView: 2.5 },
      992: { slidesPerView: 3.2 },
      1199: { slidesPerView: 4.2 },
    },
  });

  // 🧩 4. Recommended Swiper
  var rec_swiper = new Swiper(".rec_swiper", {
    slidesPerView: 4.2,
    spaceBetween: 20,
     navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: { slidesPerView: 1.2 },
      576: { slidesPerView: 2.2 },
      770: { slidesPerView: 2.2 },
      991: { slidesPerView: 2.5 },
      992: { slidesPerView: 4.2 },
    },
  });


  // product zomm

  // document.addEventListener('DOMContentLoaded', () => {
  // const mainSliderEl = document.querySelector('.product-main-slider');
  // const thumbSliderEl = document.querySelector('.product-thumb-slider');

  // if (mainSliderEl && thumbSliderEl) {
  //   const thumbSlider = new Swiper(thumbSliderEl, {
  //     direction: 'vertical',
  //     slidesPerView: 4,
  //     spaceBetween: 10,
  //     navigation: {
  //       nextEl: '.thumb-next',
  //       prevEl: '.thumb-prev',
  //     },
  //     freeMode: true,
  //     watchSlidesProgress: true,
  //     breakpoints: {
  //       768: { slidesPerView: 4 },
  //     },
  //   });

  //   const mainSlider = new Swiper(mainSliderEl, {
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     navigation: {
  //       nextEl: '.main-next',
  //       prevEl: '.main-prev',
  //     },
  //     thumbs: {
  //       swiper: thumbSlider,
  //     },
  //   });
  // }
// });


// window.addEventListener('load', () => {
//   const mainSliderEl = document.querySelector('.product-main-slider');
//   const thumbSliderEl = document.querySelector('.product-thumb-slider');

//   if (!mainSliderEl || !thumbSliderEl) return;

//   const thumbSlider = new Swiper(thumbSliderEl, {
//     direction: 'vertical',
//     slidesPerView: 4,
//     spaceBetween: 10,

//     // 🔑 IMPORTANT
//     slideToClickedSlide: true,
//     watchSlidesProgress: true,
//     watchSlidesVisibility: true,

//     navigation: {
//       nextEl: thumbSliderEl.querySelector('.thumb-next'),
//       prevEl: thumbSliderEl.querySelector('.thumb-prev'),
//     },
//   });

//   const mainSlider = new Swiper(mainSliderEl, {
//     slidesPerView: 1,
//     spaceBetween: 0,

//     navigation: {
//       nextEl: mainSliderEl.querySelector('.main-next'),
//       prevEl: mainSliderEl.querySelector('.main-prev'),
//     },

//     thumbs: {
//       swiper: thumbSlider,
//       autoScrollOffset: 1,
//     },
//   });

//   // 🔁 FORCE SYNC WHEN THUMB ARROWS ARE CLICKED
//   thumbSlider.on('slideChange', () => {
//     mainSlider.slideTo(thumbSlider.activeIndex);
//   });
// });



// Product details page slider

// $('.slider-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: false,
//     infinite: false,
//     asNavFor: '.slider-nav'
//   });

//   $('.slider-nav').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: '.slider-for',
//     vertical: true,
//     verticalSwiping: true,
//     focusOnSelect: true,
//     arrows: true,
//     infinite: false
//   });



});
